/** The driven port of the application for reporting errors to an external service. */
export abstract class ReportingService {
  abstract error(message: string, context?: Record<string, unknown>): Promise<void>;
  abstract warning(message: string, context?: Record<string, unknown>): Promise<void>;
  abstract info(message: string, context?: Record<string, unknown>): Promise<void>;
}
